import React, { Component } from 'react';
import ui from 'stores/ui';

// 设置页面pid的告诫组件
// @withPid('home')
function withPid<SelfProps>(pid: string) {
    return (WrappedComponent: React.ComponentType<SelfProps>): React.ComponentClass => {
        return class extends Component<SelfProps> {
            componentDidMount() {
                ui.setPid(pid);
            }

            render() {
                return <WrappedComponent {...this.props} />;
            }
        };
    };
}

export default withPid;
